// util/checkFile.js
import axios from "axios";
import { baseUrl } from "../baseurl";

axios.defaults.baseURL = baseUrl;

const checkLicense = async () => {
  try 
  {
    const res = await axios.get("admin/check-file");

    // Assume 200 means valid license, 400 means invalid
    if (res.status === 200) 
    {
      return res.data;
    } 
    
  } catch (error) {
    // If API fails, consider license invalid
    return error;
  }
};

export default checkLicense;
